import { FC, memo } from 'react';
import { Text, Button } from '../../../../components-v4';
import { Container, DescriptionWrapper } from './description.styled';

export const Description: FC<{ closeModal: () => void }> = memo(
  ({ closeModal }) => {
    return (
      <Container>
        <DescriptionWrapper>
          <Text variant="heading-3" color="gray.800">
            Приложение Кабинет-жителя.рф
          </Text>
          <Text variant="body-14" color="gray.500">
            Все самое важное в сфере ЖКХ — всегда под рукой
          </Text>
        </DescriptionWrapper>

        <Button mode="neutral" variant="main" size="s" onClick={closeModal}>
          Закрыть
        </Button>
      </Container>
    );
  }
);
